export default (element: HTMLElement) => {
  const dialogId = element.dataset.dialogId;
  if (!dialogId) {
    console.error(
      'Missing data-dialog-id attribute for openDialog component',
      element,
    );
    return;
  }

  element.addEventListener('click', () => {
    const dialog = document.getElementById(
      dialogId,
    ) as HTMLDialogElement | null;
    if (dialog) {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
        // Add hash to URL for back button support
        window.location.hash = dialogId;
      } else {
        alert('Váš prohlížeč nepodporuje dialogy.');
      }
    } else {
      console.error(`Dialog with id "${dialogId}" not found.`);
    }
  });
};
